import React, { useEffect, useState } from 'react'
import { Button, Card, Col, Row, Skeleton, Tag, Rate, Spin } from 'antd'
import { BankFilled } from '@ant-design/icons'
import {
  fetchMoreData,
  getAverageRating,
  getBusinessProfilePictureUrl,
  searchBusinesses,
} from 'utils'
import { useHistory } from 'react-router-dom'
import InfiniteScroll from 'react-infinite-scroll-component'
import { config } from 'configs'
import { useAuthSelector } from 'store/authSlice/authReducer'
import { useBusinessSelector } from 'store/businessSlice/businessReducer'
import { useDispatch } from 'react-redux'
import { getOrganizationBusinesses } from 'store/businessSlice/businessActions'

const MyBusiness = ({ searchText = null }) => {
  const dispatch = useDispatch()
  const history = useHistory()

  const { organization } = useAuthSelector()
  const { loading, organizationBusinesses } = useBusinessSelector()
  const [current, setCurrent] = useState([])

  const searchedData = searchBusinesses(organizationBusinesses, searchText)

  useEffect(() => {
    if (organization?.id) {
      dispatch(getOrganizationBusinesses(organization?.id))
    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    setCurrent(searchedData.slice(0, config.itemFirstLoad))
    // eslint-disable-next-line
  }, [organizationBusinesses, searchText])

  const handleBusinessSelected = (e, business) => {
    e.preventDefault()
    e.stopPropagation()
    history.push(`businesses/${business.Id}`)
  }

  return (
    <Skeleton loading={loading} active paragraph={{ rows: 18 }}>
      <div
        className="t-flex t-flex-col t-justify-between t-h-full"
        style={{ minHeight: 'calc(100vh - 270px)' }}
      >
        <InfiniteScroll
          dataLength={current.length}
          next={() => fetchMoreData(current, setCurrent, searchedData)}
          hasMore={current.length < searchedData.length}
          loader={
            <div className="t-flex t-justify-center t-items-center">
              <Spin />
            </div>
          }
        >
          <Row gutter={[24, 24]} className="t-h-full">
            {current.length === 0 && (
              <div
                className="t-h-96 t-flex t-justify-center t-items-center t-w-full"
                style={{ minHeight: 'calc(100vh - 300px)' }}
              >
                <div className="t-flex t-flex-col t-items-center t-space-y-2">
                  <BankFilled
                    style={{ fontSize: '2rem' }}
                    className="t-text-secondary-100"
                  />
                  <p>No business found</p>
                </div>
              </div>
            )}
            {current?.map((item, index) => (
              <Col span={24} lg={8} className="mb-24" key={index}>
                <Card
                  onClick={(e) => handleBusinessSelected(e, item)}
                  bodyStyle={{ paddingTop: '14px' }}
                  className="card-project-2 header-solid t-cursor-pointer"
                  title={[
                    <div className="t-flex t-items-center t-space-x-2" key={0}>
                      <div className="t-w-12 t-min-w-[3rem] t-h-12">
                        <img
                          src={getBusinessProfilePictureUrl(
                            item?.ProfilePicture,
                          )}
                          alt="card-2"
                          className="t-h-full t-w-full t-rounded-lg t-shadow-md t-object-contain"
                        />
                      </div>
                      <Col className="t-flex t-justify-between t-flex-col t-w-10/12">
                        <h6 className="t-font-bold t-text-2lg t-capitalize t-text-secondary-100 t-line-clamp-2">
                          {item?.Name || 'No Title Found'}
                        </h6>
                        <h6 className="t-font-normal t-text-xs t-capitalize">
                          {/* ${item.Address1 ? `${item.Address1}, ` : ''} */}
                          {`${item.City}, ${item.State}`}
                        </h6>
                        <div>
                          <Rate
                            disabled
                            defaultValue={getAverageRating(item?.Rating)}
                          />
                        </div>
                      </Col>
                    </div>,
                  ]}
                >
                  <p className="t-line-clamp-1 t-text-sm">
                    {item?.Description}
                  </p>
                  <div className="t-w-full t-flex t-justify-end">
                    {item?.ServiceCoverage === 'Global' ? (
                      <Tag color="orange">Global</Tag>
                    ) : (
                      <Tag color="purple">Local</Tag>
                    )}
                  </div>
                  <hr />
                  <div className="t-flex t-justify-end t-mt-4">
                    <Button type="link" size="small" className="t-rounded-full">
                      See More
                    </Button>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
        </InfiniteScroll>
      </div>
    </Skeleton>
  )
}

export { MyBusiness }
